import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Filters } from 'react-data-grid-addons';

import Core from './../../../Core/Core';
import Exporter from './../../../Core/Exporter';
import Header from './../../Header';
import ConseilorForm from './../../Conseilor/ConseilorForm';
import { ShortnameEditor } from './../../DataGrid/Editors';
import { sortRows, getRows, handleFilterChange, getValidFilterValues } from './../../Proposal/GridManager';

import ErrorBoundary from '../ErrorBoundary';
import ErrorManager from './../../../Core/ErrorManager';

const { AutoCompleteFilter, SingleSelectFilter } = Filters;

class Conseilor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealerships: [],
      conseilors: [],
      conseilor: {},
      filters: {},
      isFilterToggled: false,
    };

    this.grid = React.createRef();
    this.load = this.load.bind(this);
    this.submit = this.submit.bind(this);
    this.handleRedux = this.handleRedux.bind(this);

    // this.checkPermisions();
    this.load();
  }

  //   checkPermisions() {
  //     let user = JSON.parse(localStorage.getItem('User'));
  //     if (user && user.email) {
  //       Core.Instance.Request(Core.Address + 'GetUserFromEmail/?email=' + user.email, null, 'GET').then((json) => {
  //         if (!json[0].conseilor_access) {
  //           window.location.href = '/search';
  //         }
  //       });
  //     }
  //   }

  load() {
    Core.Instance.Request(Core.Address + 'Dealership', null, 'GET').then((json) => {
      this.setState({
        dealerships: json != null ? json.sort((a, b) => (a.name > b.name ? 1 : -1)) : [],
      });
    });
    Core.Instance.Request(Core.Address + 'Conseilor', null, 'GET').then((json) => {
      this.setState({
        conseilors: Array.isArray(json) ? json.sort((a, b) => (a.name > b.name ? 1 : -1)) : [],
      });
    });
  }

  componentDidMount() {
    document.title = 'W-F: Liste des vendeurs';
  }

  componentDidUpdate() {
    //Affiche la barre de filtres après la création de la grille
    if (this.grid.current && !this.state.isFilterToggled) {
      this.grid.current.onToggleFilter();
      this.setState({
        isFilterToggled: true,
      });
    }
  }

  handleRedux(event) {
    let conseilor = this.state.conseilor;
    conseilor[event.target.name] = event.target.value;
    this.setState({
      conseilor: conseilor,
    });
  }

  submit() {
    if (Object.getOwnPropertyNames(this.state.conseilor).length <= 0) {
      ErrorManager.Instance.Handle('Vous devez remplir le formulaire avant de pouvoir enregistrer.');
      return;
    }

    if (!Core.Instance.CheckForm(this)) return;
    let conseilor = this.state.conseilor;
    let request = null;
    if (conseilor.id) {
      request = Core.Instance.Request(Core.Address + 'Conseilor/' + conseilor.id, conseilor, 'PUT');
    } else {
      request = Core.Instance.Request(Core.Address + 'Conseilor', conseilor, 'POST');
    }
    request.then((json) => {
      ErrorManager.Instance.Info('Les modifications ont bien été enregistrées.');
      window.location.reload();
    });
  }

  deleteRow = (Conseilor_id) => {
    Core.Instance.Request(Core.Address + 'Conseilor/' + Conseilor_id, null, 'DELETE').then((json) => {
      ErrorManager.Instance.Info("L'élément a bien été supprimé.");
      window.location.reload();
    });
  };

  onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    this.setState(
      (state) => {
        const conseilors = state.conseilors.slice();
        for (let i = fromRow; i <= toRow; i++) {
          conseilors[i] = { ...conseilors[i], ...updated };
        }
        return { conseilors };
      },
      () => {
        Core.Instance.Request(
          Core.Address + 'Conseilor/' + this.state.conseilors[fromRow].id,
          this.state.conseilors[fromRow],
          'PUT',
        ).then((json) => {});
      },
    );
  };

  getCellActions = (column, row) => {
    const cellActions = {
      actions: [
        {
          icon: <span className='far fa-trash-alt' />,
          callback: () => {
            this.deleteRow(row.id);
          },
        },
        {
          icon: <span className='fa fa-edit' />,
          callback: () => {
            this.setState({
              conseilor: row,
            });
          },
        },
      ],
    };
    return cellActions[column.key];
  };

  render() {
    const columns = [
      {
        key: 'actions',
        name: '',
        resizable: true,
        width: 78,
      },
      {
        key: 'shortname',
        name: 'Affaire',
        resizable: true,
        width: 110,
        editable: true,
        sortable: true,
        filterable: true,
        filterRenderer: SingleSelectFilter,
        editor: ShortnameEditor(this.state.dealerships),
      },
      { key: 'name', name: 'Nom', width: 256, editable: true, sortable: true, filterable: true, filterRenderer: AutoCompleteFilter },
    ];

    const filteredRows = getRows(this.state.conseilors, this.state.filters);
    return (
      <ErrorBoundary>
        <Header />
        <div className='container'>
          <div className='row no-gutters'>
            <div className='col-6'>
              <div className='card m-3 p-3'>
                <div className='card-body'>
                  <div className='card-title'>
                    <span className='h4 align-middle'>Vendeurs</span>
                    {/* <button
                    className='btn btn-secondary float-right fas fa-chevron-circle-down mt-1'
                    type='button'
                    data-toggle='collapse'
                    data-target='#conseilors'
                    aria-expanded='false'
                  ></button> */}
                  </div>
                  <hr></hr>
                  <div id='conseilors' className='collapse show'>
                    {this.state.dealerships.length > 0 && this.state.conseilors.length > 0 && (
                      <ReactDataGrid
                        ref={this.grid}
                        className=''
                        columns={columns}
                        rowGetter={(i) => filteredRows[i]}
                        rowsCount={filteredRows.length + 1}
                        onGridRowsUpdated={this.onGridRowsUpdated}
                        onGridSort={(sortColumn, sortDirection) => {
                          this.setState({
                            conseilors: sortRows(this.state.conseilors, sortColumn, sortDirection),
                          });
                        }}
                        onAddFilter={(filter) => this.setState({ filters: handleFilterChange(filter, this.state.filters) })}
                        onClearFilters={() => this.setState({ filters: {} })}
                        getValidFilterValues={(columnKey) => getValidFilterValues(this.state.conseilors, columnKey)}
                        enableCellSelect={true}
                        rowHeight={50}
                        // headerRowHeight={50}
                        minHeight={750}
                        getCellActions={this.getCellActions}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='col-6'>
              <div className='card m-3 p-3'>
                <div className='card-body'>
                  <div className='card-title'>
                    {this.state.conseilor.id ? <span className='h4'>Edition d'un vendeur</span> : <span className='h4'>Ajout d'un vendeur</span>}
                    <button className='btn btn-primary float-right' onClick={this.submit}>
                      <li className='fas fa-save'> </li>
                    </button>
                  </div>
                  <hr />
                  <ConseilorForm dealerships={this.state.dealerships} conseilor={this.state.conseilor} onChange={this.handleRedux} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

export default Conseilor;



// WEBPACK FOOTER //
// ./src/Components/Views/Conseilor/Conseilor.js